import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "add-to-home-banner"
}
const _hoisted_2 = { class: "left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Get YUPA application", -1)
const _hoisted_5 = { class: "right" }
const _hoisted_6 = {
  key: 1,
  class: "add-to-home-instructions"
}
const _hoisted_7 = { class: "exit" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", null, "When the popup appears, click on Add", -1)

import Icon from "../BASE/Icon.vue";

import { useOnClickOutside } from "@/hooks/onClickOutside";
import Cookies from "js-cookie";
import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddToHomeScreen',
  setup(__props) {

const isIos = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

const isInStandaloneMode = () => "standalone" in window.navigator && window.navigator.standalone;

const isOpen = ref(false);
const displayMode = ref<"banner" | "instructions">("banner");

onMounted(() => {
  const getHomescreenCalledCookie = Cookies.get("addToHomescreenCalled");
  if (isIos() && !isInStandaloneMode() && !getHomescreenCalledCookie) {
    isOpen.value = true;
  }
});

const close = () => {
  isOpen.value = false;
  setCookie();
};

const setCookie = () => {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + 365);
  Cookies.set("addToHomescreenCalled", "true", {
    expires: exdate,
  });
};

const onInstallClick = () => {
  setCookie();
  displayMode.value = "instructions";
};

const { target } = useOnClickOutside(() => {
  if (displayMode.value == "instructions") close();
});

return (_ctx: any,_cache: any) => {
  return (isOpen.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "add-to-homescreen-conatainer",
        ref_key: "target",
        ref: target,
        style: _normalizeStyle({
      height: displayMode.value == 'banner' ? '60px' : '90%',
    })
      }, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (displayMode.value == 'banner')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("img", {
                      src: require('@/assets/YUPA-bg-white.png')
                    }, null, 8, _hoisted_3),
                    _hoisted_4
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", { onClick: onInstallClick }, "Install"),
                    _createVNode(Icon, {
                      onClick: close,
                      icon: "x",
                      width: 8,
                      height: 8
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(Icon, {
                      onClick: close,
                      icon: "x",
                      width: 8,
                      height: 8
                    })
                  ]),
                  _createElementVNode("ol", null, [
                    _createElementVNode("li", null, [
                      _createTextVNode(" Tap "),
                      _createElementVNode("img", {
                        src: require('@/assets/icons/arrow-up-ios.svg'),
                        alt: "Share Icon"
                      }, null, 8, _hoisted_8),
                      _createTextVNode(" on the bottom of the screen. ")
                    ]),
                    _createElementVNode("li", null, [
                      _createTextVNode(" Select \"Add to Home Screen "),
                      _createElementVNode("img", {
                        src: require('@/assets/icons/square-plus-ios.svg'),
                        alt: "Add Icon"
                      }, null, 8, _hoisted_9),
                      _createTextVNode(" \". ")
                    ]),
                    _hoisted_10
                  ])
                ]))
          ]),
          _: 1
        })
      ], 4))
    : _createCommentVNode("", true)
}
}

})